import React from "react";
import { Button, Col, Form, FormGroup, Input, Label, ModalBody, Row } from "reactstrap";

const FormTipoPreco = () => {
  return (<>
  </>)
}

export default FormTipoPreco;